import { Pipe, PipeTransform } from '@angular/core';

import numeral from 'numeral';

/**
 * Rounding off with significant digits
 */
@Pipe({ name: 'roundsig' })
export class RoundSigPipe implements PipeTransform {
  transform(value: number, format?: string): any {
    if (value && value > 1000) {
      if (format) {
        return numeral(value).format(format).toUpperCase();
      } else {
        return numeral(value).format('0.00a').toUpperCase();
      }
    } else {
      return value + '';
    }
  }
}
